export default __webpack_public_path__ + "static/media/picpurple.a183df13.png";